import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Cozinha = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Utensílios";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.cozinha})` }}>
        <div className="servico-hero-overlay">
          <h1>Utensílios</h1>
          {/* <p>Para quem procura por coisas de cozinha</p> */}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Cozinha & Utilidades */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.garrafaTermica} alt="" /></div>
            <h3>Bebidas</h3>
            <p>Garrafas e copos térmicos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.balancaTimers} alt="" /></div>
            <h3>Medição</h3>
            <p>Balanças digitais para cozinha.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.abridoresVinho} alt="" /></div>
            <h3>Vinhos</h3>
            <p>Abridores manuais e elétricos.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('utensílios')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('utensílios')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Cozinha;